var metaCustomJs = document.querySelector('meta[name="custom-js"]');
let isCard       = false;

if (metaCustomJs != null) {
  if (metaCustomJs.getAttribute('custom-js') == 'true') {
    isCard = true;
  }
}

await import(`${isCard ? `https://ga.jspm.io/npm:card-js@1.0.13/card-js.min.js` : `card-js`}`)

$(document).ready(function() {
  $('.pay-now-moneris').click(function() {
    var $this         = $(this)
    var form          = $this.closest('.form')
    var paymentMethod = $this.attr('data-payment-method')

    if (paymentMethod == 'Moneris') {
      if (!validateCreditNumber()) {
        alert("Please input credit number!");
        return false;
      }
    }

    form.submit()
  })
})

function validateCreditNumber() {
  var myCard      = $('#my-card');
  var cardNumber  = myCard.CardJs('cardNumber');
  var cardName    = myCard.CardJs('name');
  var expiryMonth = myCard.CardJs('expiryMonth');
  var expiryYear  = myCard.CardJs('expiryYear');
  var cvc         = myCard.CardJs('cvc');

  if ((cardNumber.length >= 1) && (expiryMonth.length >= 1) && (expiryYear.length >= 1) && (cvc.length >= 1)) {
    var creditCardInput = `<input type='hidden' name='credit_number[card_number]' value='${cardNumber}'>`+
                          `<input type='hidden' name='credit_number[expiry_month]' value='${expiryMonth}'>`+
                          `<input type='hidden' name='credit_number[expiry_year]' value='${expiryYear}'>`+
                          `<input type='hidden' name='credit_number[card_name]' value='${cardName}'>`+
                          `<input type='hidden' name='credit_number[cvc]' value='${cvc}'>`;
    document.querySelector('#input-credit-card').innerHTML = creditCardInput
    return true;
  } else {
    return false;
  }
}